import './style/Stats.css';

function Stats() {

  return (
    <div className='stats-container'>
      <div className='rating-section'>
        
      </div>
    </div>
  );
}

export default Stats;